import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Stack,
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
  Chip
} from 'investira.react.components';
import { BaseTemplate } from '../../components/templates';
import { PessoaImage } from '../../components/molecules';
import withMessage from '../../hoc/withMessage';
import { useAvaliacoesContext } from '../../contexts/AvaliacoesContext';

const AvaliacoesWaiting = memo(() => {
  const navigate = useNavigate();
  const { state, actions } = useAvaliacoesContext();

  const { cvm, logo_pessoa_id, pessoa_fantasia } = state.gestor;

  const emailResponsavel =
    state?.email_responsavel || cvm?.responsavel?.email || 'E-mail não informado';

  return (
    <BaseTemplate title={'Solicitação Enviada'} subtitle={'Nova Avaliação'} maxWidth={'md'}>
      <Stack spacing={2}>
        <Card>
          <CardContent>
            <Stack gap={2}>
              <Stack spacing={1.5}>
                <PessoaImage logoPessoaId={logo_pessoa_id} alt={pessoa_fantasia} size={50} />
                <Typography variant="h6" color="textPrimary">
                  {pessoa_fantasia}
                </Typography>
              </Stack>

              <Stack>
                <Typography variant="body1" color="textPrimary">
                  Enviamos a solicitação para o e-mail:{' '}
                  <Typography component="span" sx={{ fontWeight: 600 }}>
                    {emailResponsavel}
                  </Typography>
                </Typography>
              </Stack>
              <Divider />
              <Stack direction="row">
                <Chip
                  label="Aguardando resposta do gestor"
                  color="warning"
                  sx={{ px: 1 }}
                  size="small"
                  variant="contained"
                />
              </Stack>
            </Stack>
          </CardContent>
        </Card>

        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button
            variant="outlined"
            onClick={() => {
              actions.handleResetState();
              navigate('/avaliacoes/6d9c7884e5110addd38cdeb3ef2a0aab');
            }}>
            Visualizar Avaliação (TESTE)
          </Button>

          <Button
            variant="contained"
            onClick={() => {
              actions.handleResetState();
              navigate('/avaliacoes');
            }}>
            Voltar para Avaliações
          </Button>
        </Stack>
      </Stack>
    </BaseTemplate>
  );
});

AvaliacoesWaiting.displayName = 'AvaliacoesWaiting';

export default withMessage(AvaliacoesWaiting);
